module.exports = "<div #theletter class=\"letter-icon-wrapper\"><span class=\"letter-icon\">{{letter}}</span></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/components/letter-icon/letter-icon.component.html
// module id = ./src/app/core.module/components/letter-icon/letter-icon.component.html
// module chunks = main